import axios from "axios";
import { baseURL } from "@/general";
const adminApi = axios.create({
  baseURL,
});
export const userLogin = async (values) => {
  try {
    const response = await adminApi.post("general/login", values);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const validaAvisoPrivacidad = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.get("general/validaAvisoPrivacidad",config);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const confirmaAvisoPrivacidad = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post(
      "general/confirmaAvisoPrivacidad",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const resetPassword = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post("general/resetPassword", values,config);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const verificaAcceso = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post("general/verificaAcceso", values, config);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};


export const getGruposProfesor = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post("grupo/getGruposProfesorByPeriodo",values,config);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};


export const getListaInscritos = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post("grupo/getListaInscritos",values,config);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};


export const saveCalificaciones = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post("inscripcion/procesaCalificacionesInscripciones",values,config);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};


export const changePassword = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post("general/changePassword",values,config);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

